import React from "react";
import { useSelector } from "react-redux";
import useResizer from "../../../../hooks/use-resizer";
import { useObjectAnimation } from "../../../Animations/hooks/AnimationContext";

export const Image = ({ imgId, currentSlideIdProp = null, isPropertyPreviewMode = false, previewModeProperies = null }) => {
  const [addResizer, removeResizer, dragEvent] = useResizer();
  const imageAnim = useObjectAnimation(imgId);
  let currentSlideId = useSelector((state) => state.slide.currentSlideId);
  if (currentSlideIdProp) {
    currentSlideId = currentSlideIdProp;
  }
  const imageObj = useSelector((state) => state.slide.slides[currentSlideId].image);
  const existingSlides = useSelector((state) => state.slide.slides);
  const currentSlideData = existingSlides?.[currentSlideId];
  const imageData = imageObj?.[imgId] || {};
  const handelAddResizer = (e) => {
    addResizer(e.target.parentElement);
  }

  const currentSvgStyles = currentSlideData?.additionalData?.elementsData?.[imgId]?.properties || {};
  const sourceStyles = isPropertyPreviewMode && previewModeProperies ? previewModeProperies : currentSvgStyles;

  let internalProperties = {
    isTransparent: false,
    strokeWidth: 0,
    backgroundColor: "#fff",
    borderColor: "#fff",
    width: imageData?.styles?.width || 40,
    height: imageData?.styles?.height || 40,
    borderRadius: 0,
    strokeUnit: "px",
    rotation: 0,
    borderStyle: 'solid',
    borderRadiusUnit: 'px',
  };

  if (sourceStyles) {
    internalProperties = {
      ...internalProperties,
      ...sourceStyles,
    };
  }

  return (
    <div
      tabIndex="0"
      onClick={isPropertyPreviewMode ? undefined : (e) => handelAddResizer(e)}
      onBlur={isPropertyPreviewMode ? undefined : (e) => removeResizer(e.target)}
      key={imgId}
      id={imgId}
      className="image"
      style={{
        ...imageData.styles,
        width: isPropertyPreviewMode ? 138 : internalProperties.width,
        height: isPropertyPreviewMode ? 138 : internalProperties.height,
        transform: `rotate(${internalProperties.rotation}deg)`,
        // Transform-based entrance effects compose this so rotation survives playback.
        '--ms-rot': `${internalProperties.rotation}deg`,
        position: isPropertyPreviewMode ? 'unset' : imageData.styles?.position,
        cursor: isPropertyPreviewMode ? 'default' : 'move',
        ...imageAnim.style,
      }}
    >
      <img
        style={{
          opacity: `${internalProperties.opacity}%`,
          borderRadius: `${internalProperties.borderRadius}${internalProperties.borderRadiusUnit}`,
          borderColor: internalProperties.borderColor,
          borderWidth: `${internalProperties.strokeWidth}${internalProperties.strokeUnit}`,
          borderStyle: internalProperties.borderStyle,
        }}
        id={imgId}
        src={imageObj[imgId] ? imageObj[imgId].imageb64 : ""}
        onMouseDown={dragEvent}
        alt="..." />
    </div>
  );
};
